var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38 76C17 76 0 59 0 38S17 0 38 0s38 17 38 38-17 38-38 38zm0-72C19.3 4 4 19.3 4 38s15.3 34 34 34 34-15.3 34-34S56.7 4 38 4zM27.4 57.7c-.3 0-.7-.1-1-.3-.6-.4-1-1-1-1.7V19.6c0-.7.4-1.4 1-1.7.6-.4 1.4-.3 2 0L58 36c.6.4 1 1 1 1.7s-.4 1.3-1 1.7l-29.6 18c-.3.2-.6.3-1 .3zm2-34.5v29l23.8-14.5-23.8-14.5z"}));
}

Play.defaultProps = {"fill":"currentColor","viewBox":"0 0 76 76","id":"play"};

module.exports = Play;

Play.default = Play;
